// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"373":"accesos","728":"usuarios","913":"default"}[chunkId] || chunkId) + "-legacy." + {"373":"1c1eff78","386":"6b16a428","728":"e21415fb","913":"b58c2351"}[chunkId] + ".js";
};